import { useEffect, useState } from "react";
import { accountRequest, type AdministrationView } from "./account-api";
import { Button, Control } from "./components";

/** The accounts service returns only scopes this signed-in administrator can invite into. */
export function InviteWorkspaceUser() {
  const [data, setData] = useState<AdministrationView>(),
    [scope, setScope] = useState(""),
    [name, setName] = useState(""),
    [email, setEmail] = useState(""),
    [role, setRole] = useState("tester"),
    [busy, setBusy] = useState(false),
    [message, setMessage] = useState(""),
    [link, setLink] = useState("");
  useEffect(() => {
    let active = true;
    void accountRequest<AdministrationView>("/administration")
      .then((value) => {
        if (active) setData(value);
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, []);
  const scopes = data?.scopes.filter((scope) => scope.kind !== "global") || [];
  if (!scopes.length) return null;
  const selected =
    scopes.find((item) => `${item.kind}:${item.id}` === scope) || scopes[0];
  return (
    <details className="panel padded">
      <summary>Invite a person to a company or site</summary>
      <form
        onSubmit={async (event) => {
          event.preventDefault();
          if (busy) return;
          setBusy(true);
          setMessage("");
          setLink("");
          try {
            const result = await accountRequest<{ url?: string }>(
              "/invitations",
              {
                name,
                email,
                scope: selected,
                role,
                root: false,
                delivery: "link",
              },
            );
            setLink(result.url || "");
            setMessage(
              "Invitation created. Share the one-use setup link privately.",
            );
          } catch (error) {
            setMessage((error as Error).message);
          } finally {
            setBusy(false);
          }
        }}
      >
        <fieldset disabled={busy} style={{ border: 0, padding: 0 }}>
          <Control label="Invite into">
            <select
              value={`${selected.kind}:${selected.id}`}
              onChange={(event) => setScope(event.target.value)}
            >
              {scopes.map((item) => (
                <option
                  key={`${item.kind}:${item.id}`}
                  value={`${item.kind}:${item.id}`}
                >
                  {item.kind === "site"
                    ? `Site: ${data?.sites.find((site) => site.id === item.id)?.name || item.id}`
                    : item.kind === "company"
                      ? `Company: ${data?.companies.find((company) => company.id === item.id)?.name || item.id}`
                      : "Application"}
                </option>
              ))}
            </select>
          </Control>
          <Control label="Name">
            <input
              required
              value={name}
              onChange={(event) => setName(event.target.value)}
            />
          </Control>
          <Control label="Email">
            <input
              type="email"
              required
              value={email}
              onChange={(event) => setEmail(event.target.value)}
            />
          </Control>
          <Control label="Role">
            <select
              value={role}
              onChange={(event) => setRole(event.target.value)}
            >
              <option value="tester">Tester</option>
              <option value="editor">Editor</option>
              <option value="assetManager">Asset manager</option>
              <option value="administrator">Administrator</option>
            </select>
          </Control>
          <Button type="submit">
            {busy ? "Creating invitation…" : "Create invitation"}
          </Button>
        </fieldset>
      </form>
      {message && <p role="status">{message}</p>}
      {link && (
        <Control label="One-use setup link">
          <input
            readOnly
            value={link}
            onFocus={(event) => event.target.select()}
          />
        </Control>
      )}
    </details>
  );
}
